import React, { useEffect, memo } from "react";
import useTimer from "../customHooks/useTimer";
import "../stylesheets/countdownTimer.css";

function CountdownTimer({
  startDate,
  endDate,
  currentDate,
  containerStyle = {},
  boxStyle = {},
  seperatorStyle = {},
  handler,
}) {
  const timerState = useTimer({ startDate, endDate, currentDate });

  function convertToGrouping(data) {
    return String(data).padStart(2, "0");
  }

  useEffect(() => {
    if (handler && timerState?.days !== null) handler();
  }, [timerState?.days]);

  return currentDate <= endDate && timerState?.seconds !== null ? (
    <span className="countdownTimerContainer" style={containerStyle}>
      {timerState.days !== 0 && (
        <>
          <span className="countdownTimerValue" style={boxStyle}>
            {convertToGrouping(timerState.days)}
          </span>
          <span className="countdownTimerSeparator" style={seperatorStyle}>
            :
          </span>
        </>
      )}
      <span className="countdownTimerValue" style={boxStyle}>
        {convertToGrouping(timerState.hours)}
      </span>
      <span className="countdownTimerSeparator" style={seperatorStyle}>
        :
      </span>
      <span className="countdownTimerValue" style={boxStyle}>
        {convertToGrouping(timerState.minutes)}
      </span>
      <span className="countdownTimerSeparator" style={seperatorStyle}>
        :
      </span>
      <span className="countdownTimerValue" style={boxStyle}>
        {convertToGrouping(timerState.seconds)}
      </span>
    </span>
  ) : null;
}

export default memo(CountdownTimer);
